import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {multipleSelector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';

declare var ko: any;

export class discountsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected statusFilter: multipleSelector_template;
    protected categoryFilter: multipleSelector_template;
    protected branchFilter: multipleSelector_template;

    protected getTemplateHtml(): string {
        return `
            <div class="sub-header w-justify">
                <div class="w-left">
                    ${this.statusFilter.getHtmlBuild()}
                    ${this.categoryFilter.getHtmlBuild()}
                    ${this.branchFilter.getHtmlBuild()}
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-statuses"></div>
                   <div id="selected-categories"></div>
                   <div id="selected-branches"></div>
                </div>
            </div>

            <div class="list-header w-justify">
               <div class="w-left"><button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add Discount</button></div>
               <div class="w-center">${this.filter.getHtmlBuild()}</div>
               <div class="w-right">${this.pagination.getHtmlBuild()}</div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idMerchant') }, css: { 'list-sort-desc': orderByAndDirection()=='idMerchant_DESC', 'list-sort-asc': orderByAndDirection()=='idMerchant_ASC' }">Merchant</span></th>
                            <th><span>Categories</span></th>
                            <th><span>Branches</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='isActive_DESC', 'list-sort-asc': orderByAndDirection()=='isActive_ASC' }">Status</span></th>
                            <th><span>Start Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'endDate') }, css: { 'list-sort-desc': orderByAndDirection()=='endDate_DESC', 'list-sort-asc': orderByAndDirection()=='endDate_ASC' }">End Date</span></th>
                            <th><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: discounts">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: merchantName"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: categoriesDisplay"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: branchesDisplay"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span class="status-badge" data-bind="text: isActive ? 'Active' : 'Inactive', css: { 'active': isActive, 'inactive': !isActive }"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: startDateDisplay"></span></a></td>
                            <td data-bind="event: { click: $parent.viewDiscount }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: endDateDisplay"></span></a></td>
                            <td>
                                <button class="btn border highlight only-icon icon i-delete" data-bind="event: { click: $parent.onClickDelete }" type="button"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-statuses');
        this.statusFilter.setTagContainerCaption('Selected statuses:');

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel('Categories');
        this.categoryFilter.setFilterContainerClass('margin-neg');
        this.categoryFilter.setTagContainerId('selected-categories');
        this.categoryFilter.setTagContainerCaption('Selected Categories:');

        this.branchFilter = new multipleSelector_template("branchFilter", this.getTemplateViewModel(), this.caller);
        this.branchFilter.setLabel('Available To');
        this.branchFilter.setFilterContainerClass('margin-neg');
        this.branchFilter.setTagContainerId('selected-branches');
        this.branchFilter.setTagContainerCaption('Selected Branches:');
    }

    protected getTemplateName(): string {
        return "discountsList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            discounts: ko.observableArray([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewDiscount: (data, event) => {
                self.viewDiscount(data.id, event);
            },
            onClickDelete: (value, data, event) => {
                self.onClickDelete(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd();
            }
        };
    }

    public getViewModelForRequest() {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                status: this.getTemplateViewModel().statusFilter.selectedItems,
                categories: this.getTemplateViewModel().categoryFilter.selectedItems,
                branches: this.getTemplateViewModel().branchFilter.selectedItems
            }
        };
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() === "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.filterList();
    }

    public onClickAdd() {
        this.caller.add();
    }

    protected viewDiscount(data, event): any {
        this.caller.viewDiscount(data);
    }

    public onClickDelete(discount: any): void {
        window.event.stopPropagation();
        const deleteConfirmation: boolean = confirm('Are you sure you want to delete (' + discount.name + ') discount? This action cannot be undone.');
        if (deleteConfirmation === true) {
            this.caller.delete(discount.id);
        }
    }

    public setCategoryOptions(items: any[]): void {
        this.categoryFilter.setItems(items);
    }

    public setBranchOptions(items: any[]): void {
        this.branchFilter.setItems(items);
    }

    public setStatusFilterItems(items: any[]): void {
        this.statusFilter.setItems(items);
    }

    public setListData(discounts: any[]): void {
        const brandId = this.caller.getBrandId();
        
        discounts.forEach((discount) => {
            discount['emakiView'] = '/brand/' + brandId + '/config/discounts/view/' + discount.id + '/';
            discount['merchantName'] = discount.merchant ? discount.merchant.name : '';
            discount['categoriesDisplay'] = discount.categories ? discount.categories.map(c => c.name).join(', ') : '';
            discount['branchesDisplay'] = discount.branches ? discount.branches.map(b => b.name).join(', ') : '';
            discount['startDateDisplay'] = discount.startDate ? discount.startDate.substring(0, 10) : '-';
            discount['endDateDisplay'] = discount.endDate ? discount.endDate.substring(0, 10) : 'Ongoing';
        });

        this.getTemplateViewModel().discounts(discounts);
    }

    public setResultInfo(nbResults, nbPages, execTime): void {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setPageNumber(page: number): void {
        this.pagination.getTemplateViewModel().pageNumber(page);
    }

    public setItemCount(count: number): void {
        this.pagination.getTemplateViewModel().itemCount(count);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/discountsList_template.ts